module.exports = __webpack_public_path__ + "static/black_earth_priest-f2f6ee69a55355f1fd9516c3d05f620f.jpeg";